import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Octopath Traveler Cyrus No-BG Notes" mdxType="SEO" />
    <h3 {...{
      "id": "cyrus-ch1"
    }}>{`Cyrus Ch.1`}</h3>
    <p>{`After getting cutscened outside the palace, go back in and turn right for a `}<strong parentName="p">{`Thunder S`}</strong>{`.`}<br parentName="p"></br>{`
`}{`During the scrutinize mission, scrutinize the guard by the screen split for a `}<strong parentName="p">{`Light S`}</strong>{`.`}<br parentName="p"></br>{`
`}<em parentName="p">{`Quiz: Option 1, Option 2`}</em><br parentName="p"></br>{`
`}{`When the dungeon opens, go to the south screen and scrutinize the girl in the plaza for a `}<strong parentName="p">{`Light M`}</strong></p>
    <h5 {...{
      "id": "weapon-shop"
    }}>{`Weapon Shop`}</h5>
    <p>{`Buy Quartz Rod and equip`}</p>
    <p>{`Subterranean Study: Kill 2 encounters for 10 JP. Pick `}<strong parentName="p">{`Light S`}</strong>{` to the far right of the boss trigger.`}</p>
    <h4 {...{
      "id": "russell"
    }}>{`Russell`}</h4>
    <p><em parentName="p">{`Heal when below 40 HP`}</em><br parentName="p"></br>{`
`}{`1. Fireball`}<br parentName="p"></br>{`
`}{`2. Thunder S`}<br parentName="p"></br>{`
`}{`3. Light S`}<br parentName="p"></br>{`
`}{`4. Icewind`}<br parentName="p"></br>{`
`}{`5. Staff x3`}<br parentName="p"></br>{`
`}{`6. Light S`}<br parentName="p"></br>{`
`}{`7. Staff`}<br parentName="p"></br>{`
`}{`8. Staff x3`}<br parentName="p"></br>{`
`}{`9. Fireball x4`}</p>
    <p>{`Go to The Whistlewood in North Atlasdam Flats and pick up `}<strong parentName="p">{`$1500`}</strong>{` red chest.`}<br parentName="p"></br>{`
`}{`Kill one of these encounters with `}<strong parentName="p">{`Light M`}</strong>{`:`}</p>
    <ul>
      <li parentName="ul">{`2 Flatlands Froggen IV, 2 Spud Bugs (need 2 JP extra)`}</li>
      <li parentName="ul">{`2 Flatlands Froggen V, 2 Spud Bugs`}</li>
      <li parentName="ul">{`5 Spud Bugs`}</li>
      <li parentName="ul">{`Anything with a Cait`}</li>
    </ul>
    <h5 {...{
      "id": "skills"
    }}>{`Skills`}</h5>
    <p>{`Cyrus: Lightning Blast, Firestorm, Evasive Maneuvers`}</p>
    <p>{`Go to `}<strong parentName="p">{`Noblecourt`}</strong>{`, Scrut & Pick `}<strong parentName="p">{`Thunder L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Atlasdam`}</strong>{`, go to `}<strong parentName="p">{`Rippletide`}</strong>{`. `}</p>
    <h3 {...{
      "id": "tressa-ch1"
    }}>{`Tressa Ch.1`}</h3>
    <h4 {...{
      "id": "mikk--makk"
    }}>{`Mikk & Makk`}</h4>
    <p>{`Thunder L`}</p>
    <p>{`You have 1 M Stones to use for random battles if you don't buy the extra.`}</p>
    <p>{`Head to Merchant Shrine`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$1200`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Warrior Shrine`}</strong>{`.`}</p>
    <p>{`Tag `}<strong parentName="p">{`Stonegard`}</strong>{`. Optionally buy `}<strong parentName="p">{`Wind M`}</strong>{` from lady by entrance. Head to `}<strong parentName="p">{`Shrine of the Runeblade`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Light L`}</strong>{`. Pick `}<strong parentName="p">{`$50000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Rippletide`}</strong>{`. Head to `}<strong parentName="p">{`Sunshade`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-ch1"
    }}>{`Primrose Ch.1`}</h3>
    <h4 {...{
      "id": "helgenish"
    }}>{`Helgenish`}</h4>
    <p>{`Light L`}</p>
    <p>{`Head to `}<strong parentName="p">{`Quarrycrest`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cyrus-ch2-start"
    }}>{`Cyrus Ch.2 Start`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Wind M`}</strong>{`, Buy `}<strong parentName="p">{`Thunder M + Thunder L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Quiz Option 2 x3`}<br parentName="p"></br>{`
`}{`After Quiz head to Bolderfall`}</p>
    <h3 {...{
      "id": "therion-ch1"
    }}>{`Therion Ch.1`}</h3>
    <h4 {...{
      "id": "heathecote"
    }}>{`Heathecote`}</h4>
    <p>{`Thunder L + Thunder/Ice M + M Stone`}</p>
    <p>{`Steal `}<strong parentName="p">{`Nourishing S & Pom S`}</strong><br parentName="p"></br>{`
`}{`Head towards `}<strong parentName="p">{`Duskbarrow`}</strong>{`.`}</p>
    <p>{`Get `}<strong parentName="p">{`Hunter Shrine`}</strong>{`, Pick `}<strong parentName="p">{`Olive L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`S&Q. Pick `}<strong parentName="p">{`Copper-Filled Pouch`}</strong>{`. Enter `}<strong parentName="p">{`Duskbarrow`}</strong>{`.`}</p>
    <p>{`Buy `}<strong parentName="p">{`Curious Antique`}</strong>{`. Buy `}<strong parentName="p">{`2 Healing Grape Bunch`}</strong>{` from shop. Pick `}<strong parentName="p">{`$30000`}</strong>{`, pick `}<strong parentName="p">{`Curious Antique`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`. Head to Purgation.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Light L`}</strong>{`, `}<strong parentName="p">{`Forbidden Dagger`}</strong>{`, `}<strong parentName="p">{`$20000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Stonegard`}</strong>{`, head to `}<strong parentName="p">{`Merchant Shrine`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Merchant Shrine`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Quarrycrest`}</strong></p>
    <h3 {...{
      "id": "cyrus-ch2-continued"
    }}>{`Cyrus Ch.2 Continued`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`Hunter`}</strong>{`, Leghold`}</li>
        <li parentName="ul">{`Tressa: Hired Help`}</li>
        <li parentName="ul">{`Therion: Armor Corrosive`}</li>
        <li parentName="ul">{`Prim: `}<strong parentName="li">{`Merchant`}</strong>{`, Hired Help`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "gideon"
    }}>{`Gideon`}</h4>
    <h5 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Armor Corrosive x2`}</li>
      <li parentName="ul">{`Merchants: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Merchants: HHV x3`}</li>
    </ul>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Empowering Bracelet`}</strong>{`, Scrut `}<strong parentName="p">{`Curious Antique`}</strong>{`, buy `}<strong parentName="p">{`Empowering Ring`}</strong>{`. Pick `}<strong parentName="p">{`Curious Antique`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Stonegard`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cyrus-ch3"
    }}>{`Cyrus Ch.3`}</h3>
    <p>{`Do scruts.`}<br parentName="p"></br>{`
`}{`On Second Screen`}<br parentName="p"></br>{`
`}{`Allure `}<strong parentName="p">{`guy by church for quest (42%)`}</strong>{`. Do this first so if you fail you can reload autosave.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`3 Silver Armor (attach to all but Cyrus)`}</li>
        <li parentName="ul">{`3 Silver Helmet (attach to all but Cyrus)`}</li>
      </ul>
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <p>{`All gold items, Forbidden Dagger (NOT Gideon's Dagger), Refreshing Jam + Olive L`}</p>
    </Menu>
    <p>{`Quiz `}<em parentName="p">{`Option 3 x2`}</em><br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Fire L`}</strong>{` from Tobias`}</p>
    <p>{`Talk to `}<strong parentName="p">{`guy by fountain`}</strong>{` to finish quest. `}<strong parentName="p">{`(+5k, Royal Crest)`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Light L`}</strong>{` & `}<strong parentName="p">{`Shadow L`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Royal Crest`}</li>
        <li parentName="ul">{`Therion: Empowering Ring`}</li>
        <li parentName="ul">{`Primrose: Gideon's Dagger, Empowering Bracelet`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Sidestep, Warrior, Incite + Thousand Spears`}</li>
        <li parentName="ul">{`Therion: Shackle Foe`}</li>
      </ul>
      <h5 {...{
        "id": "skills-1"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Cover`}</li>
      </ul>
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Nourishing S Therion`}</li>
        <li parentName="ul">{`Heal party with grapes`}</li>
      </ul>
    </Menu>
    <p>{`Save before Yvon.`}</p>
    <h4 {...{
      "id": "yvon"
    }}>{`Yvon`}</h4>
    <p>{`This is basically pray for no Tornado or double tap. By far worst part of the run. Good luck :)`}<br parentName="p"></br>{`
`}{`Can buff def with first action, not sure if worth.`}</p>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: LB / Defend / Leghold Yvon`}</li>
      <li parentName="ul">{`Tressa/Prim: HHM / HHB x2 / Defend`}</li>
      <li parentName="ul">{`Therion: Shackle Yvon / Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2--3"
    }}>{`Turn 2 & 3`}</h5>
    <ul>
      <li parentName="ul">{`Break Yvon + Adds, throw 3 L Stones.`}</li>
      <li parentName="ul">{`If possible boost Corrosive T3 (can Pom S to setup).`}</li>
    </ul>
    <p>{`You'll have dead turns here almost always.`}<br parentName="p"></br>{`
`}{`You can recover a character dying T1 if they already had their action.`}</p>
    <h5 {...{
      "id": "turn-4"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Staff x4`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
      <li parentName="ul">{`Therion: Corrosive / Attack`}</li>
      <li parentName="ul">{`Prim: Attack / Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Merchants: HHV x4`}</li>
    </ul>
    <p>{`Finish Ch3, TP `}<strong parentName="p">{`Duskbarrow`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cyrus-ch4"
    }}>{`Cyrus Ch.4`}</h3>
    <p>{`Quiz `}<em parentName="p">{`Option 2 x3`}</em></p>
    <p>{`Pick `}<strong parentName="p">{`$50000`}</strong>{`. Pick `}<strong parentName="p">{`$20000`}</strong>{`, `}<strong parentName="p">{`Shadow L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Pom L`}</strong>{`, Grape Bunch if needed (need 2)`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Ice L`}</strong>{`, `}<strong parentName="p">{`Knight Shield`}</strong></p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: -Royal Crest`}</li>
        <li parentName="ul">{`Therion: -Empowering Ring +Knight Shield`}</li>
        <li parentName="ul">{`Primrose: -Empowering Bracelet +Empowering Ring`}</li>
        <li parentName="ul">{`Tressa: +Royal Crest`}</li>
        <li parentName="ul">{`Cyrus: +Empowering Bracelet`}</li>
      </ul>
      <h5 {...{
        "id": "skills-2"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Therion: HP Thief`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Incidental Attack, Fleetfoot`}</li>
      </ul>
      <h5 {...{
        "id": "items-1"
      }}>{`Items`}</h5>
      <p>{`Heal all with grapes`}</p>
    </Menu>
    <p>{`Need at least 90150$ for fight. Should have $90000 - $93500, depending on battles killed & HH usage vs Yvon.`}</p>
    <h4 {...{
      "id": "lucia"
    }}>{`Lucia`}</h4>
    <p>{`Need Merchant + Therion before Lucia. If both Merchants before Lucia use HHM with Prim.`}<br parentName="p"></br>{`
`}{`Format is (Primrose HHM / Tressa HHM)`}</p>
    <h5 {...{
      "id": "turn-1-2"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Leghold x2`}</li>
      <li parentName="ul">{`Tressa: Thousand Spears / HHM x2`}</li>
      <li parentName="ul">{`Primrose: HHM x2 / Grape Bunch`}</li>
      <li parentName="ul">{`Therion: Shackle Foe x2 `}{`[25/28]`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Rain of Arrows`}</li>
      <li parentName="ul">{`Tressa: Incite`}</li>
      <li parentName="ul">{`Primrose: Grape Bunch / Pom L Tressa`}</li>
      <li parentName="ul">{`Therion: HP Thief `}{`[20/23]`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Rain of Arrows`}</li>
      <li parentName="ul">{`Tressa: Sidestep x4`}</li>
      <li parentName="ul">{`Primrose: Grape Bunch`}</li>
      <li parentName="ul">{`Therion: HP Thief `}{`[15/18]`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-1"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Rain of Arrows`}</li>
      <li parentName="ul">{`Tressa: Thousand Spears`}</li>
      <li parentName="ul">{`Primrose: Pom L Tressa / Attack`}</li>
      <li parentName="ul">{`Therion: Armor Corrosive x2 `}{`[9/11]`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5-1"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Axe x4`}</li>
      <li parentName="ul">{`Tressa: Sidestep x2`}</li>
      <li parentName="ul">{`Primrose: Attack x2 / Attack x4`}</li>
      <li parentName="ul">{`Therion: Defend `}{`[3/3]`}</li>
    </ul>
    <h5 {...{
      "id": "turn-6"
    }}>{`Turn 6`}</h5>
    <ul>
      <li parentName="ul">{`Therion: Attack x3 `}{`[Break]`}</li>
      <li parentName="ul">{`Cyrus: L Stone`}</li>
      <li parentName="ul">{`Tressa: HHV x3`}</li>
      <li parentName="ul">{`Primrose: Pom L Tressa`}</li>
    </ul>
    <h5 {...{
      "id": "turn-7"
    }}>{`Turn 7`}</h5>
    <ul>
      <li parentName="ul">{`Therion & Cyrus: L Stone`}</li>
      <li parentName="ul">{`Tressa & Primrose: HHV x4`}</li>
    </ul>
    <p>{`Do scruts, TP and run to last scrut. Quiz `}<em parentName="p">{`Option 2, 3, 2`}</em>{`. GG!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      